import React from 'react'

const Pricing = () => {
    return (
        <div className="pricing">
            <h1>Pricing</h1>
            <div className="price-col">
                <div className="insidecon">
                    <div className="insideleft">
                        <p>For 1 month Membership</p>
                    </div>
                    <div className="insideright">
                        <p>Rs-1500</p>
                    </div>
                </div>
                <div className="insidecon">
                    <div className="insideleft">
                        <p>For 3 month Membership</p>
                    </div>
                    <div className="insideright">
                        <p>Rs-3000 (1000 Rs/M)</p>
                    </div>
                </div>
                <div className="insidecon">
                    <div className="insideleft">
                        <p>For 6 month Membership</p>
                    </div>
                    <div className="insideright">
                        <p>Rs-5400 (900 Rs/M)</p>
                    </div>
                </div>
                <div className="insidecon">
                    <div className="insideleft">
                        <p>For 12 month Membership</p>
                    </div>
                    <div className="insideright">
                        <p>Rs-10000 (833 Rs/M)</p>
                    </div>
                </div>
                <div className="insidecon">
                    <div className="insideleft">
                        <p>Personal Trainer Charge</p>
                    </div>
                    <div className="insideright">
                        <p>Rs-3000/M</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Pricing
